<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Dashboard",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Dashboard",
      items: [""]
    };
  },
  mounted() {},
};
</script>

<template>
  <Layout>
    <PageHeader :title="$t('navbar.dropdown.user.list.settings')" :items="items" />
    <div class="row">

      <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <h4 class="report-title mb-4">
              <i class="bx bx-briefcase-alt font-size-20 align-middle me-2"></i>
              {{$t('setting.company.text')}}
            </h4>
            <div class="card-text mb-2"><router-link :to="'setting/company/calendar'">{{$t('setting.company.calendar')}}</router-link></div>
            <div class="card-text mb-2"><router-link :to="'setting/company/sequence'">{{$t('setting.company.auto-number')}}</router-link></div>
            <div class="card-text mb-2"><router-link :to="'setting/company/import'">{{$t('setting.company.import-data')}}</router-link></div>
            <div class="card-text mb-2"><router-link :to="'setting/company/round'">{{$t('setting.company.round.text')}}</router-link></div>
            <div class="card-text mb-2"><router-link :to="'setting/company/footerheader'">{{$t('setting.company.footer-header')}}</router-link></div>
            <div class="card-text mb-2" style="color: white">report</div>
          </div>
        </div>
      </div>

      <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <h4 class="report-title mb-4">
              <i class="bx bx-building font-size-20 align-middle me-2"></i>
              {{$t('setting.property.text')}}
            </h4>
            <div class="card-text mb-2"><router-link :to="'setting/property/project'">{{$t('setting.property.project')}}</router-link></div>
            <div class="card-text mb-2"><router-link :to="'setting/property/owner'">{{$t('setting.property.project-owner.text')}}</router-link></div>
            <div class="card-text mb-2"><router-link :to="'setting/property/type'">{{$t('setting.property.property-type.text')}}</router-link></div>
            <div class="card-text mb-2"><router-link :to="'setting/property/payment/term'">{{$t('setting.property.payment-term.text')}}</router-link></div>
            <div class="card-text mb-2"><router-link :to="'setting/property/group'">{{$t('setting.property.group')}}</router-link></div>
            <div class="card-text mb-2"><router-link :to="'setting/property/plan'">{{$t('setting.property.plan')}}</router-link></div>
            
          </div>
        </div>
      </div>

      <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <h4 class="report-title mb-4">
              <i class="bx bx-repost font-size-20 align-middle me-2"></i>
              {{$t('setting.pl.text')}}
            </h4>
            <!-- <div class="card-text mb-2"><router-link :to="'setting/pl/account'">{{$t('setting.pl.account.text')}}</router-link></div>
            <div class="card-text mb-2"><router-link :to="'setting/pl/account/type'">{{$t('setting.pl.account-type.text')}}</router-link></div> -->
            <div class="card-text mb-2"><router-link :to="'setting/pl/config'">{{$t('setting.pl.config')}}</router-link></div>
            <div class="card-text mb-2"><router-link :to="'setting/pl/user'">{{$t('setting.pl.user-accounting')}}</router-link></div>
            <div class="card-text mb-2" style="color: white">report</div>
            <div class="card-text mb-2" style="color: white">report</div>
          </div>
        </div>
      </div>

      <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <h4 class="report-title mb-4">
              <i class="bx bx-shield-alt-2 font-size-20 align-middle me-2"></i>
              {{$t('setting.security.text')}}
            </h4>
            <div class="card-text mb-2"><router-link :to="'setting/security/user'">{{$t('setting.security.user.text')}}</router-link></div>
            <div class="card-text mb-2"><router-link :to="'setting/security/role'">{{$t('setting.security.role.text')}}</router-link></div>
            <div class="card-text mb-2" style="color: white">report</div>
            <div class="card-text mb-2" style="color: white">report</div>
          </div>
        </div>
      </div>

      <div class="col-lg-8">
        <div class="card">
          <div class="card-body">
            <h4 class="report-title mb-4">
              <i class="bx bxs-brightness font-size-20 align-middle me-2"></i>
              {{$t('setting.configuration.text')}}
            </h4>
            <div class="row">
              <div class="col-lg-4">
                <div class="card-text mb-2"><router-link :to="'setting/customer/type'">{{$t('setting.configuration.customer-type.text')}}</router-link></div>
                <div class="card-text mb-2"><router-link :to="'setting/seller/type'">{{$t('setting.configuration.seller-type.text')}}</router-link></div>
                <div class="card-text mb-2"><router-link :to="'setting/supplier/type'">{{$t('setting.configuration.supplier-type.text')}}</router-link></div>
                <div class="card-text mb-2"><router-link :to="'setting/block-time'">{{$t('setting.configuration.property-block-time')}}</router-link></div>
              </div>
            
              <div class="col-lg-4">
                <div class="card-text mb-2"><router-link :to="'setting/loan-template'">{{$t('setting.configuration.loan-template.text')}}</router-link></div>
                <div class="card-text mb-2"><router-link :to="'setting/contract'">{{$t('setting.configuration.contract-template.text')}}</router-link></div>
                <div class="card-text mb-2"><router-link :to="'properties/receipt'">{{$t('setting.configuration.receipt-template')}}</router-link></div>
                <div class="card-text mb-2"><router-link :to="'setting/expense'">{{$t('setting.configuration.expense-template')}}</router-link></div>
              </div>
            
              <div class="col-lg-4">
                <div class="card-text mb-2"><router-link :to="'setting/commission'">{{$t('setting.configuration.commission-rule.text')}}</router-link></div>
                <div class="card-text mb-2"><router-link :to="'setting/schedule'">{{$t('setting.configuration.payment-schedule-template.text')}}</router-link></div>
                <div class="card-text mb-2"><router-link :to="'setting/incomeexpense/item'">{{$t('setting.income-expense-item.text')}}</router-link></div>
                <div class="card-text mb-2"><router-link :to="'setting/accountbinding/1'">{{$t('setting.account-binding.text')}}</router-link></div>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
